import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { TextAction } from '@node-space/storybook-components/dist/TextAction'
import { Box } from '@node-space/ui-components'
import { FullScreenLayout } from 'components/layout/FullScreenLayout'
import { PublicPageLayout } from 'components/layout/PublicPageLayout'
import { ExternalLinks } from 'constants/ExternalLinks'
import { UIConfig } from '../helpers/types'
import { InfoHeader } from './InfoHeader'

export interface EmbeddedWrapperProps extends PropsWithChildren {
  isUsEntity: boolean
  uiConfig: UIConfig
}

export const EmbeddedWrapper = ({ isUsEntity, uiConfig, children }: EmbeddedWrapperProps) => {
  const { t } = useTranslation()

  const UsFooter = isUsEntity && (
    <>
      {` ${t('embeddedCustomerTerms.footerAdditionUs')} `}
      <TextAction
        text={t('embeddedCustomerTerms.footerLinkUs')}
        linkTo={ExternalLinks.licencesAndDisclosures}
      />
    </>
  )

  const Footer = (
    <>
      {t('embeddedCustomerTerms.footer')}
      {UsFooter}
    </>
  )

  return uiConfig?.isBranded ? (
    <PublicPageLayout header={<InfoHeader />} footer={Footer}>
      {children}
    </PublicPageLayout>
  ) : (
    <FullScreenLayout {...(uiConfig?.isDarkMode && { className: `bg-[#232323]` })}>
      <Box flexCol width="full" gap={24} padding={32} className="md:px-[60px] md:pb-12 md:pt-10">
        {children}
      </Box>
    </FullScreenLayout>
  )
}
